/**
 * Password strength validation utilities
 */
export const validatePasswordStrength = (password) => {
  return {
    minLength: password.length >= 6,
    hasLetter: /[a-zA-Z]/.test(password),
    hasNumber: /\d/.test(password),
    hasSpecial: /[!@#$%^&*()_+\-=\[\]{}|;:,.<>?]/.test(password)
  }
}

export const isPasswordValid = (password) => {
  const strength = validatePasswordStrength(password)
  return strength.minLength && strength.hasLetter && strength.hasNumber && strength.hasSpecial
}

export const getPasswordStrengthColor = (password) => {
  const strength = validatePasswordStrength(password)
  const count = Object.values(strength).filter(Boolean).length

  if (count <= 2) return 'bg-red-500'
  if (count === 3) return 'bg-orange-500'
  return 'bg-green-500'
}

/**
 * Password strength meter component
 */
const PasswordStrengthMeter = ({ password }) => {
  if (!password) return null

  const strength = validatePasswordStrength(password)
  const strengthColor = getPasswordStrengthColor(password)

  return (
    <div className="mt-3 space-y-2">
      {/* Visual meter bar */}
      <div className={`h-1 rounded-full transition-colors duration-300 ${strengthColor}`}></div>

      {/* Requirements checklist */}
      <div className="text-xs text-gray-600 dark:text-gray-400 space-y-1">
        <p className={strength.minLength ? 'text-green-600 dark:text-green-400' : ''}>
          {strength.minLength ? '✓' : '○'} Mínimo 6 caracteres
        </p>
        <p className={strength.hasLetter ? 'text-green-600 dark:text-green-400' : ''}>
          {strength.hasLetter ? '✓' : '○'} Pelo menos uma letra
        </p>
        <p className={strength.hasNumber ? 'text-green-600 dark:text-green-400' : ''}>
          {strength.hasNumber ? '✓' : '○'} Pelo menos um número
        </p>
        <p className={strength.hasSpecial ? 'text-green-600 dark:text-green-400' : ''}>
          {strength.hasSpecial ? '✓' : '○'} Pelo menos um caractere especial (!@#$%^&*)
        </p>
      </div>
    </div>
  )
}

export default PasswordStrengthMeter
